/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ countdown_hour: NonNullable<unknown> }} Cn_Android_Paywall_3_Day_TitleInputs */

const en_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const ar_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const de_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const es_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const fr_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const it_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const ja_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const ko_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const pt_br_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const ru_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const th_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const tr_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Plus Benefits End in ${i?.countdown_hour} Hours!`)
};

const zh_cn_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 会员权益
还剩 ${i?.countdown_hour} 小时`)
};

const zh_tw_cn_android_paywall_3_day_title = /** @type {(inputs: Cn_Android_Paywall_3_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 会员权益
还剩 ${i?.countdown_hour} 小时`)
};

/**
* | output |
* | --- |
* | "Your Plus Benefits End in {countdown_hour} Hours!" |
*
* @param {Cn_Android_Paywall_3_Day_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cn_android_paywall_3_day_title = /** @type {((inputs: Cn_Android_Paywall_3_Day_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cn_Android_Paywall_3_Day_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cn_android_paywall_3_day_title(inputs)
	if (locale === "ar") return ar_cn_android_paywall_3_day_title(inputs)
	if (locale === "de") return de_cn_android_paywall_3_day_title(inputs)
	if (locale === "es") return es_cn_android_paywall_3_day_title(inputs)
	if (locale === "fr") return fr_cn_android_paywall_3_day_title(inputs)
	if (locale === "it") return it_cn_android_paywall_3_day_title(inputs)
	if (locale === "ja") return ja_cn_android_paywall_3_day_title(inputs)
	if (locale === "ko") return ko_cn_android_paywall_3_day_title(inputs)
	if (locale === "pt_br") return pt_br_cn_android_paywall_3_day_title(inputs)
	if (locale === "ru") return ru_cn_android_paywall_3_day_title(inputs)
	if (locale === "th") return th_cn_android_paywall_3_day_title(inputs)
	if (locale === "tr") return tr_cn_android_paywall_3_day_title(inputs)
	if (locale === "zh_cn") return zh_cn_cn_android_paywall_3_day_title(inputs)
	return zh_tw_cn_android_paywall_3_day_title(inputs)
});